import React from 'react';
import SpecGrid from './SpecGrid';
import {
  faRulerVertical, faRulerHorizontal, faRuler, faWeightHanging, faGaugeHigh,
  faShieldHalved, faChartLine, faBorderAll, faLayerGroup,
} from '@fortawesome/free-solid-svg-icons';

const DETAIL_FIELDS = [
  { icon: faRulerVertical, label: 'Długość', key: 'module_length', unit: 'mm' },
  { icon: faRulerHorizontal, label: 'Szerokość', key: 'module_width', unit: 'mm' },
  { icon: faRuler, label: 'Grubość', key: 'module_thickness', unit: 'mm' },
  { icon: faWeightHanging, label: 'Waga', key: 'weight', unit: 'kg' },
  { icon: faGaugeHigh, label: 'Sprawność', key: 'efficiency', unit: '%' },
  { icon: faShieldHalved, label: 'Gwarancja produktowa', key: 'product_warranty', unit: 'lat' },
  { icon: faChartLine, label: 'Gwarancja na wydajność', key: 'eff_warranty', unit: 'lat' },
  { icon: faBorderAll, label: 'Obramowanie', key: 'frame_colour' },
  { icon: faLayerGroup, label: 'Rodzaj', key: 'type' },
];

export const isMeaningfulValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'number') {
    if (Number.isNaN(value) || value === 0) return false;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '' || trimmed.toLowerCase() === 'null' || trimmed === '0') return false;
  }
  return true;
};

export const hasDisplayValue = isMeaningfulValue;

const formatFieldValue = (raw, unit) => {
  if (!isMeaningfulValue(raw)) return null;
  return unit ? `${raw} ${unit}` : String(raw);
};

export const hasMoreProductDetails = (product) => {
  if (!product) return false;
  return DETAIL_FIELDS.some((f) => isMeaningfulValue(product[f.key]));
};

const MoreProductDetails = ({ product }) => {
  const items = DETAIL_FIELDS
    .map((f) => ({ icon: f.icon, label: f.label, value: formatFieldValue(product[f.key], f.unit) }))
    .filter((item) => item.value !== null);

  if (items.length === 0) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 mb-12">
      <h2 className="text-lg sm:text-xl font-bold text-blue-600 mb-4">Informacje szczegółowe</h2>
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6 lg:p-8">
        <SpecGrid items={items} />
      </div>
    </div>
  );
};

export default MoreProductDetails;
